
export const StrikeColors = {

  magenta: '#ff0098',
  blue: '#3d3cf5',
  black: '#000',
  white: '#fff',
  navy: `#003152`,

};